/**
 * Remove a script from the document by its id
 */
export default (document: Document, id: string) => {
  const element = document.getElementById(id)

  element?.parentNode?.removeChild(element)
}
